import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import StorefrontIcon from "@material-ui/icons/Storefront";
import { changeAppState, useAppState } from "../../../../common/appState";
import { SuccessButton } from "../../../shared/Button/SuccessButton";
import { WhiteButton } from "../../../shared/Button/WhiteButton";

export function ItemShopButton() {
    const [isDarkMode] = useAppState("isDarkMode");
    const c = useCoinStyles();

    return (
        <Card
            className={c.card}
            onClick={() => {
                changeAppState("shopPanelState", { open: true });
            }}
        >
            {isDarkMode ? (
                <WhiteButton
                    className={c.darkButton}
                    startIcon={<StorefrontIcon />}
                >
                    Shop
                </WhiteButton>
            ) : (
                <SuccessButton
                    className={c.button}
                    startIcon={<StorefrontIcon />}
                >
                    Shop
                </SuccessButton>
            )}
        </Card>
    );
}
const useCoinStyles = makeStyles(theme => ({
    card: {
        position: "absolute",
        top: -35,
        height: 35,
        right: 43,
        padding: 2,
    },
    button: {
        maxHeight: 30,
        minHeight: 30,
        fontSize: "15px !important",
        lineHeight: 1,
    },
    darkButton: {
        maxHeight: 30,
        minHeight: 30,
        fontSize: "15px !important",
        lineHeight: 1,
        borderColor: theme.palette.success.dark,
        color: theme.palette.success.dark,
        "&:hover": {
            color: theme.palette.primary.main,
        },
    },
}));
